import { useSyncExternalStore } from 'react';

/* "View as client": lets a Triton admin see the app the way a client user does,
   for demos and support. It is a presentation switch only — the flag that hides
   admin surfaces in the SPA reads false while it is on — and the Worker's
   authorization is untouched; an admin remains an admin server-side. Kept in
   sessionStorage so a reload mid-demo does not snap back to the admin view,
   and per tab so it cannot leak into a colleague's session. */

const KEY = 'tq.viewAsClient';
const listeners = new Set<() => void>();

function read(): boolean {
  try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; }
}
let current = read();

export function isViewingAsClient(): boolean { return current; }

export function setViewAsClient(on: boolean): void {
  current = on;
  try { if (on) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch { /* storage unavailable: in-memory only */ }
  for (const l of listeners) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => { listeners.delete(l); };
}

export function useViewAsClient(): [boolean, (on: boolean) => void] {
  const on = useSyncExternalStore(subscribe, isViewingAsClient, () => false);
  return [on, setViewAsClient];
}
